



























































































import { defineComponent } from '@vue/composition-api';
import HForm from '@/ui/components/base/HForm.vue';
import HButton from '@/ui/components/base/HButton.vue';
import HTextField from '@/ui/components/base/HTextField.vue';
import HToast from '@/ui/components/base/HToast.vue';

import useI18n from '@/ui/composables/base/use-i18n';
import useSignupTexts from '@/ui/composables/signup/use-signup-texts';
import useSignupRules from '@/ui/composables/signup/use-signup-rules';
import useSignupVariables from '@/ui/composables/signup/use-signup-variables';
import useSignupFunctions from '@/ui/composables/signup/use-signup-functions';
import useFormRules from '../../composables/base/use-form-rules';

export default defineComponent({
  name: 'SignupForm',
  components: {
    HForm,
    HButton,
    HTextField,
    HToast,
  },
  setup(_, { root, refs }) {
    const i18n = useI18n(root);
    const signupVariables = useSignupVariables();
    const signupTexts = useSignupTexts(i18n);
    const sigupRules = useSignupRules(signupVariables, useFormRules(i18n), signupTexts);
    const {
      submit,
      validateUsername,
      goToLandingPage,
    } = useSignupFunctions(root, i18n, refs, signupVariables);

    return {
      ...signupVariables,
      ...sigupRules,
      ...signupTexts,
      submit,
      validateUsername,
      goToLandingPage,
    };
  },
});
